import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { useMsal } from '@azure/msal-react';
import MD5 from "crypto-js/md5";
import { loginRequest } from './authConfig';
import { useSession } from './providers/SessionProvider';

const siteKey = '6LedyWwrAAAAACiVz8IQ2S5EWYL6j26r2Jbz6Hkk';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LoginForm = () => {
  const [formData, setFormData] = useState({ emp_code: '', password: '' });
  const [responseMessage, setResponseMessage] = useState('');
  const [captchaValue, setCaptchaValue] = useState(null);
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { startSession } = useSession();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCaptchaChange = (value) => setCaptchaValue(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaValue) {
      setResponseMessage('Please complete the reCAPTCHA.');
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}central_login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData),
      });

      const result = await response.json();
      if (!response.ok || !result.status) {
        setResponseMessage(result.error || 'Login failed');
        return;
      }

      const token = result.token;
      const expirationTime = Date.now() + 7190000;
      localStorage.setItem('authToken', token);
      localStorage.setItem('emp_code', formData.emp_code);
      localStorage.setItem('exp', expirationTime);

      const profileResponse = await fetch(`${API_BASE_URL}central_profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const profileResult = await profileResponse.json();
      if (profileResult.status) {
        const hashedPassword = MD5('adnet2008').toString();
        if (hashedPassword === profileResult.profile.password) {
          navigate('/change_password');
          return;
        }

        localStorage.setItem('userProfile', JSON.stringify(profileResult.profile));
        localStorage.setItem('comp_name', profileResult.profile.comp_name);
        sessionStorage.setItem('emp_password1', profileResult.profile.password);
        sessionStorage.setItem('is_osb', profileResult.profile.is_osb);
        sessionStorage.setItem('is_ticket', profileResult.profile.is_ticket);
        sessionStorage.setItem('is_ot', profileResult.profile.is_ot);
        sessionStorage.setItem('is_dmg', profileResult.profile.is_dmg);
        sessionStorage.setItem('is_phhr', profileResult.profile.is_phhr);
        sessionStorage.setItem('is_uniform_access_given', profileResult.profile.is_uniform_access_given);
        sessionStorage.setItem('check_list', profileResult.profile.check_list);
        sessionStorage.setItem('vdcapp_admin', profileResult.profile.vdcapp_admin);
        sessionStorage.setItem('is_randr', profileResult.profile.is_randr);
        // ... store other session values
        startSession();
        navigate('/dashboard');
      } else {
        setResponseMessage('Error fetching profile: ' + profileResult.message);
      }
    } catch (error) {
      setResponseMessage('Error: ' + error.message);
    }
  };

  const handleMicrosoftLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest);
      const idToken = loginResponse.idToken;

      const verifyResponse = await fetch(`${API_BASE_URL}ms-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      const result = await verifyResponse.json();
      if (result.status) {
        const token = result.token;
        localStorage.setItem('authToken', token);
        localStorage.setItem('exp', Date.now() + 7190000);

        const profileResponse = await fetch(`${API_BASE_URL}central_profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const profileResult = await profileResponse.json();
        if (profileResult.status) {
          localStorage.setItem('userProfile', JSON.stringify(profileResult.profile));
          localStorage.setItem('emp_code', profileResult.profile.emp_code);
          sessionStorage.setItem('emp_password1', profileResult.profile.password);
          sessionStorage.setItem('is_osb', profileResult.profile.is_osb);
        sessionStorage.setItem('is_ticket', profileResult.profile.is_ticket);
        sessionStorage.setItem('is_ot', profileResult.profile.is_ot);
        sessionStorage.setItem('is_dmg', profileResult.profile.is_dmg);
        sessionStorage.setItem('is_phhr', profileResult.profile.is_phhr);
        sessionStorage.setItem('is_uniform_access_given', profileResult.profile.is_uniform_access_given);
        sessionStorage.setItem('check_list', profileResult.profile.check_list);
        sessionStorage.setItem('vdcapp_admin', profileResult.profile.vdcapp_admin);
        sessionStorage.setItem('is_randr', profileResult.profile.is_randr);
          startSession();
          navigate('/dashboard');
        } else {
          setResponseMessage('Error fetching profile: ' + profileResult.message);
        }
      } else {
        setResponseMessage(result.message);
      }
    } catch (error) {
      console.error('Microsoft login error:', error);
      setResponseMessage('Microsoft authentication failed.');
    }
  };

  const handleForgetPassword = () => {
    navigate('./forget-password');
  };

  return (
    <div style={{
      height: '100vh', backgroundColor: '#f0f2f5', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px'
    }}>
      <div style={{
        display: 'flex', flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
        backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden',
        boxShadow: '0 0 25px rgba(0,0,0,0.1)', width: '100%', maxWidth: '950px'
      }}>
        {/* Left */}
        <div style={{
          flex: 1, padding: '40px 20px', background: 'linear-gradient(to right, #d9e4f5, #f8f9fa)',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
        }}>
          <img src="./assets/img/tey.jpg" alt="Dashboard" style={{
            width: '100%', maxWidth: '100%', borderRadius: '10px', marginBottom: '20px'
          }} />
          <h2 style={{ color: '#000', fontWeight: 'bold', textAlign: 'center' }}>Welcome to VDC Central Dashboard</h2>
          <p style={{ color: '#333', textAlign: 'center' }}>Your centralized gateway to internal apps.</p>
        </div>

        {/* Right */}
        <div style={{ flex: 1, padding: '40px', backgroundColor: '#fff' }}>
          <img src="assets/img/logo2.png" alt="Logo" style={{ width: '100%', display: 'block', margin: '0 auto 10px' }} />
          <p style={{ textAlign: 'center', color: '#555' }}>Please login to continue</p>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="emp_code"
              placeholder="BM ID"
              value={formData.emp_code}
              onChange={handleChange}
              required
              className="form-control mb-3"
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
              className="form-control mb-3"
            />
            <div className="text-center mb-2">
              <b style={{ cursor: 'pointer' }} onClick={handleForgetPassword}>Forgot Password?</b>
            </div>
            <div className="d-flex justify-content-center mb-3">
              <ReCAPTCHA sitekey={siteKey} onChange={handleCaptchaChange} />
            </div>
            <button type="submit" className="btn btn-success w-100 mb-2">Login</button>
          </form>

          <button onClick={handleMicrosoftLogin} className="btn btn-primary w-100">
            Login with Microsoft
          </button>

          {responseMessage && (
            <div className="text-danger mt-3 text-center" style={{ fontSize: '14px' }}>
              {responseMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
